import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useToast } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { generatePath, useHistory } from "react-router-dom";

import { useGetMiscRequirement } from "../api/wrappers/useGetMiscRequirement";
import { DOCUMENT_DETAILS_FULL_PATH } from "../paths";

interface DocumentSearchNotFoundProps {
  searchTerm: string;
}

export function DocumentSearchNotFound(props: DocumentSearchNotFoundProps) {
  const { searchTerm } = props;

  useLogEffect(APP_V2_USER_EVENTS.DOCUMENT_SEARCH_NOT_FOUND_VIEWED, { searchTerm });

  const history = useHistory();
  const { showErrorToast } = useToast();

  const { refetch: getMiscellaneousRequirement, isFetching: isFetchingMiscRequirement } =
    useGetMiscRequirement({ enabled: false });

  return (
    <Stack flex={1} alignItems="center" justifyContent="center" spacing={5}>
      <Text semibold variant="h4" align="center">
        Document not found
      </Text>
      <LoadingButton
        variant="outlined"
        size="small"
        isLoading={isFetchingMiscRequirement}
        onClick={async () => {
          logEvent(APP_V2_USER_EVENTS.DOCUMENT_SEARCH_NOT_FOUND_ADD_DOCUMENT_CLICKED);

          const { data: miscellaneousRequirement, isError } = await getMiscellaneousRequirement();

          if (isError || !isDefined(miscellaneousRequirement)) {
            showErrorToast(
              "Something went wrong initiating the miscellaneous document upload. Please try again in a moment"
            );
            return;
          }

          history.push(
            generatePath(DOCUMENT_DETAILS_FULL_PATH, {
              requirementId: miscellaneousRequirement.id,
            })
          );
        }}
      >
        Add Document
      </LoadingButton>
    </Stack>
  );
}
